var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m47.682 40.034-6.914 6.182a1.18 1.18 0 0 1-1.536 0l-6.914-6.183a.9.9 0 0 1 0-1.373 1.18 1.18 0 0 1 1.537 0l5.059 4.523V14.627h2.172v28.556l5.06-4.523a1.18 1.18 0 0 1 1.536 0 .9.9 0 0 1 0 1.374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m8.97 48.098 10.345-26.66h17.599v2h-16.23l-9.223 23.77h10.838l12 7.87H45.7l12-7.87H68.54l-9.224-23.77H43.086v-2h17.599L71.03 48.103l-3.725 22.351H12.49zm37.329 8.98 12-7.87h10.52l-3.207 19.246H14.199L11.17 49.21h10.532l12 7.868z",
    clipRule: "evenodd"
  })));
};
export default SvgArchive;